
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  actions?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ children, className = '', title, actions }) => {
  return (
    <div className={`dark:bg-surface bg-light-surface rounded-lg border dark:border-border-color border-light-border-color shadow-lg ${className}`}>
      {(title || actions) && (
        <div className="px-4 py-3 sm:px-6 border-b dark:border-border-color border-light-border-color flex justify-between items-center">
          {title && <h3 className="text-lg font-semibold leading-6 dark:text-text-primary text-light-text-primary">{title}</h3>}
          {actions && <div className="flex items-center space-x-2">{actions}</div>}
        </div>
      )}
      <div className="p-4 sm:p-6">{children}</div>
    </div>
  );
};

export default Card;
